<template>
  <div v-if="formVisible">
    <el-dialog
      v-dragDialog
      :title="formTitle"
      :visible.sync="formVisible"
      width="520px"
      :close-on-click-modal="false"
    >
      <el-form :model="addForm" ref="dataForm" label-width="110px" :rules="formRules">
        <el-form-item label="选择测试:" prop="Check">
          <checkSelector v-model="addForm.Check" :tenant="tenantKey" />
        </el-form-item>
        <el-form-item v-if="addForm.Check && addForm.Check.Key" label="客户来源:" >
          <el-input v-model="addForm.Check.Member.Channel" placeholder="请输入客户来源"/>
        </el-form-item>
        <el-form-item label="回访日期:" prop="VisitDate">
          <el-date-picker
            v-model="addForm.VisitDate"
            type="date"
            size="small"
            placeholder="请选择回访日期"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item label="回访备注:" prop="Description">
          <el-input
            v-model="addForm.Description"
            type="textarea"
            :rows="5"
            placeholder="请输入回访备注"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { save } from "@/api/customer/visitRecord";
import checkSelector from "./checkSelector.vue";
export default {
  components: { checkSelector },
  props: {
    tenantKey: {
      default: "",
    },
  },
  data() {
    return {
      formVisible: false,
      formTitle: "添加回访记录",
      addForm: {},
      formRules: {
        Check: [{ required: true, message: "请选择检测", trigger: "change" }],
        VisitDate: [{ required: true, message: "请选择回访日期", trigger: "change" }],
      },
    };
  },
  methods: {
    handleCreate() {
      this.formTitle = "添加回访记录";
      this.formVisible = true;
      this.addForm = {
        Check: "",
        VisitDate: "",
        Description: "",
      };
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate();
      });
    },
    handleUpdate(row) {
      this.addForm = JSON.parse(JSON.stringify(row));
      this.addForm.VisitDate = this.format.dateFormat(row.VisitDate);
      this.formTitle = "修改回访记录";
      this.formVisible = true;
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate();
      });
    },
    handleSubmit() {
      if(this.addForm.Check && this.addForm.Check.Key && !this.addForm.Check.Member.Channel)
      {
            this.$message.error("请输入客户来源");
            return;
      }
      this.$refs.dataForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认提交吗？", "提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
        }).then(() => {
          save(this.addForm).then((response) => {
            if (response) {
              this.formVisible = false;
              this.$emit("update");
            }
          });
        });
      });
    },
  },
};
</script>
